import { render, staticRenderFns } from "./CustomerHindi.vue?vue&type=template&id=370332da&"
import script from "./CustomerHindi.vue?vue&type=script&lang=js&"
export * from "./CustomerHindi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports